'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SaveTripButton } from '~/components/TripOverview/hero/SaveTripButton';
import { ShareTripButton } from '~/components/TripOverview/hero/ShareTripButton';
import { useTripId } from '~/hooks/useTripId';
import styles from '../TripOverviewPage.module.css';
import { EmissionsBadge } from './EmissionsBadge';
type TripOverviewIntroProps = {
  title: string;
  dayCount: number;
  totalCarbonFootprint: number;
  journeyCarbonUsage?: {
    carEquivalent: number;
    flightEquivalent: number;
  };
};
const carbonFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
export const TripOverviewIntro = t0 => {
  const $ = _c(21);
  const {
    title,
    dayCount,
    totalCarbonFootprint,
    journeyCarbonUsage
  } = t0;
  const t = useTranslations("journey");
  const tripId = useTripId();
  const showEmissionsSection = totalCarbonFootprint > 0;
  const hasUsageComparisons = typeof journeyCarbonUsage?.carEquivalent === "number" && typeof journeyCarbonUsage?.flightEquivalent === "number";
  const carbonSavings = hasUsageComparisons ? 100 / journeyCarbonUsage.flightEquivalent * totalCarbonFootprint - 100 : undefined;
  let t1;
  if ($[0] !== carbonSavings) {
    t1 = typeof carbonSavings === "number" && Number.isFinite(carbonSavings) ? Math.round(carbonSavings) : undefined;
    $[0] = carbonSavings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedCarbonSavings = t1;
  let t2;
  if ($[2] !== title) {
    t2 = <h1 className={styles.introTitle} id="overview-description-heading">{title}</h1>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShareTripButton className={styles.introActionButton} size="large" iconVariant="overviewIntro" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== tripId) {
    t4 = <div className={styles.introActions}>{t3}<SaveTripButton tripId={tripId} className={styles.introActionButton} size="large" iconVariant="overviewIntro" /></div>;
    $[5] = tripId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className={styles.introTitleRow}>{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== dayCount || $[11] !== formattedCarbonSavings || $[12] !== hasUsageComparisons || $[13] !== journeyCarbonUsage || $[14] !== showEmissionsSection || $[15] !== t || $[16] !== totalCarbonFootprint) {
    t6 = showEmissionsSection ? <div className={styles.emissionsRow}><strong className={styles.emissionsDays}>{t("days_count", {
          count: dayCount
        })}</strong><div className={styles.emissionsBox}><p className={styles.emissionsSummary}>{carbonFormatter.format(totalCarbonFootprint)} kg CO<sub>2</sub></p>{typeof formattedCarbonSavings === "number" ? <EmissionsBadge totalCarbonFootprint={totalCarbonFootprint} formattedCarbonSavings={formattedCarbonSavings} hasUsageComparisons={hasUsageComparisons} journeyCarbonUsage={journeyCarbonUsage} /> : null}</div></div> : null;
    $[10] = dayCount;
    $[11] = formattedCarbonSavings;
    $[12] = hasUsageComparisons;
    $[13] = journeyCarbonUsage;
    $[14] = showEmissionsSection;
    $[15] = t;
    $[16] = totalCarbonFootprint;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <section id="overview-description" className={styles.introBlock} aria-labelledby="overview-description-heading">{t5}{t6}</section>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};